import { render, staticRenderFns } from "./customBtns.vue?vue&type=template&id=f5dccec0"
import script from "./customBtns.vue?vue&type=script&lang=js"
export * from "./customBtns.vue?vue&type=script&lang=js"
import style0 from "./customBtns.vue?vue&type=style&index=0&id=f5dccec0&prod&scope=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports